<template>
  <b-container fluid id="student-dropout" class="mt-4">
    <div class="title">
      <h6>{{ lastName }}, {{ firstName }} -- {{ school }}</h6>
    </div>
    <div id="alerts" ref="dropout-alert">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >You have successfully added a dropout/register record!</b-alert
      >
      <b-alert :show="formError" dismissible variant="warning"
        >Something went wrong. Please refresh and try again, or contact the site
        admin.</b-alert
      >
    </div>
    <div id="dropout-form">
      <b-row id="headers">
        <b-col sm="3">Date</b-col>
        <b-col sm="3">Dropout or Register?</b-col>
        <b-col sm="4">Reason</b-col>
        <b-col sm="2"></b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <b-form-input
            name="date"
            type="date"
            id="date"
            v-model.lazy="date"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <b-form-select
            name="dropout_or_register"
            type="text"
            id="year"
            v-model.lazy="dropout_or_register"
          >
            <option disabled value>Select an option</option>
            <option value="drop out">Drop Out</option>
            <option value="register">Register</option>
          </b-form-select>
        </b-col>
        <b-col sm="4">
          <b-form-input
            type="text"
            name="reason"
            v-model.lazy="reason"
          ></b-form-input>
        </b-col>
        <b-col sm="2">
          <b-button :variant="'primary'" @click="addOrUpdate">{{
            buttonTitle
          }}</b-button>
        </b-col>
      </b-row>
      <br />
    </div>
    <div id="dropout-table">
      <b-table
        v-cloak
        responsive
        :fields="fields"
        :items="studentDropouts"
        :striped="true"
        :bordered="true"
        :hover="true"
        stacked="md"
      >
        <template slot="cell(edit)" slot-scope="row">
          <b-link @click.stop="editDropout(row)" class="edit">Edit</b-link>
        </template>
        <template slot="cell(del)" slot-scope="row">
          <b-link @click.stop="deleteDropout(row)" class="delete"
            >DELETE</b-link
          >
        </template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";
import DropoutService from "../services/DropoutService";

export default {
  name: "StudentDropout",
  props: {
    firstName: String,
    lastName: String,
    school: String,
  },
  mixins: [flash, scrollTo],
  data() {
    return {
      id: "",
      disabled: false,
      required: false,
      changeTitle: false,
      formError: false,
      student_uuid: this.$route.params.id,
      date: "",
      dropout_or_register: "",
      reason: "",
      fields: [
        { key: "date", label: "Date", sortable: true },
        {
          key: "dropout_or_register",
          label: "Dropout or Register?",
          sortable: true,
        },
        { key: "reason", label: "Reason", sortable: true },
        { key: "edit", label: "Edit", sortable: true },
        { key: "del", label: "DELETE", sortable: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      studentDropouts: "dropouts/getStudentDropouts",
    }),
    showTitle() {
      return this.lastName.length;
    },
    buttonTitle() {
      return this.changeTitle ? "Edit Record" : "Submit Record";
    },
  },
  methods: {
    ...mapActions({
      GET_DROPOUTS: "dropouts/GET_STUDENT_DROPOUTS",
    }),
    async addDropout() {
      if (!this.date || !this.dropout_or_register) {
        this.formError = true;
        this.flashError();
        return;
      }
      const payload = {
        date: this.date,
        student_uuid: this.student_uuid,
        dropout_or_register: this.dropout_or_register,
        reason: this.reason,
      };
      await DropoutService.addDropoutRecord(payload);
      await this.scrollTo("dropout-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.GET_DROPOUTS();
    },
    clearForm() {
      this.date = "";
      this.dropout_or_register = "";
      this.reason = "";
    },
    editDropout(row) {
      this.id = row.item.id;
      this.changeTitle = true;
      this.date = row.item.date;
      this.dropout_or_register = row.item.dropout_or_register;
      this.reason = row.item.reason;
      this.studentDropouts.splice(row.index, 1);
    },
    async updateDropout() {
      if (!this.date || !this.dropout_or_register) {
        this.formError = true;
        this.flashError();
      } else {
        const payload = {
          id: this.id,
          date: this.date,
          student_uuid: this.student_uuid,
          dropout_or_register: this.dropout_or_register,
          reason: this.reason,
        };
        await DropoutService.updateDropoutRecord(payload);
        await this.scrollTo("dropout-alert");
        await this.flashSuccess();
        this.clearForm();
        this.formError = false;
        this.changeTitle = false;
        await this.GET_DROPOUTS();
      }
    },
    async deleteDropout(row) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this dropout record?"
      );
      if (confirmDelete) {
        await DropoutService.deleteDropoutRecord(row.item.id);
        await this.GET_DROPOUTS();
      }
    },
    async addOrUpdate() {
      if (this.buttonTitle === "Edit Record") {
        this.updateDropout();
      } else {
        this.addDropout();
      }
    },
  },
  mounted() {
    this.GET_DROPOUTS();
  },
};
</script>

<style scoped>
#headers,
#date {
  text-align: left;
}
</style>
